import Player from '@vimeo/player'
const initMastHeadVimeo = () => {
  const playerNodeList = document.querySelectorAll('.masthead__vimeo')
  if (!playerNodeList || !playerNodeList.length) return

  // Init player and fade-in video
  const playerElements = [...playerNodeList]
  const players = playerElements.map((playerElement) => {
    const player = new Player(playerElement)
    const showPlayer = () => {
      playerElement.style.opacity = 1
    }
    // Show vimeo when loaded faster than the JS parser, or wait for video to finish loading.
    player
      .getPaused()
      .then((isPaused) =>
        isPaused ? player.on('play', showPlayer) : showPlayer()
      )
    return player
  })

  // Allow user to pause/unpause video on click for accessibility
  const masthead = document.querySelector('.masthead')
  masthead.addEventListener('click', () => {
    players.forEach((player) => {
      player.getPaused().then((paused) => {
        !paused ? player.pause() : player.play()
      })
    })
  })
}
export default initMastHeadVimeo
